export default [
  {
    path: '/',
    redirect: { name: 'getJob' }
  },
  {
    path: '*',
    name: 'error_404',
    component: () => import('@views/error-page/404.vue')
  },
  {
    path: '/searchHome',
    name: 'searchHome',
    component: () => import('@views/home/searchHome.vue'),
    meta: {
      title: '首页'
    }
  }
]
